(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("aws-sdk/global"));
	else if(typeof define === 'function' && define.amd)
		define("aws_amplify_core", ["aws-sdk/global"], factory);
	else if(typeof exports === 'object')
		exports["aws_amplify_core"] = factory(require("aws-sdk/global"));
	else
		root["aws_amplify_core"] = factory(root["aws-sdk/global"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 